import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import * as _ from 'underscore';
import 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Flat} from '../../shared/models/flat.model';
import {FlatManagerService} from '../../shared/service/flat-manager.service';
import {Flats} from '../../shared/models/flats.model';

@Component({
  selector: 'app-flats',
  templateUrl: './flats.component.html',
  styleUrls: ['./flats.component.scss']
})
export class FlatsComponent implements OnInit {

  sortOptions: object[] = [];
  selectedSortOption: {} = {};

  levelOptions: object[] = [];
  selectedLevelOption: {} = {};

  statusOptions: StatusInterface[] = [];
  selectedStatus: StatusInterface;


  maxPrice = 99000000;
  maxPriceValue = 99000000;
  minPrice = 15000000;
  minSizeValue = 30;
  minNumberOfRoomsValue = 1;
  maxNumberOfRooms = 2;

  minSize = 30;
  maxSize = 100;

  flats: Flat[] = [];
  imagesList: object[] = [];

  constructor(private router: Router,
              private flatService: FlatManagerService, private httpClient: HttpClient) {

    this.initProjectOptions();
    this.initSortOptions();
    this.initLevelOptions();

    this.selectedSortOption = this.sortOptions[0];
    this.selectedLevelOption = this.levelOptions[3];
    this.selectedStatus = this.statusOptions[0];


    this.flatService.getFlatsAndSave();
    this.flatService.flats.subscribe((flats: Flats) => {
      if (flats) {
        this.flats = flats.items;
        this.setPriceRange();
        this.setSizeRange();
        this.setMaxNumberOfRooms();
      }
    });
  }

  ngOnInit() {
  }

  setMaxNumberOfRooms() {
    this.maxNumberOfRooms = Math.max(...this.flats.map(item => item.numberOfRooms || 0));
  }

  setPriceRange() {
    this.maxPrice =
      Math.max(...this.flats.map(item => item.price));
    this.minPrice =
      Math.min(...this.flats.map(item => item.price));
    this.maxPriceValue = this.maxPrice;
  }

  setSizeRange() {
    this.maxSize =
      Math.max(...this.flats.map(item => item.size));
    this.minSize =
      Math.min(...this.flats.map(item => item.size));
    this.minSizeValue = this.minSize;
  }

  getFlatList() {

    const flats = this.flats.filter((flat: Flat) => {

      if (this.selectedStatus.value === 'ALL') {
        return true;
      }

      if (this.selectedStatus.value === 'FOR_SALE') {
        return !flat.reserved && !flat.soldOut;
      }

      if (this.selectedStatus.value === 'SOLD') {
        return flat.soldOut;
      }


      if (this.selectedStatus.value === 'RESERVED') {
        return flat.reserved;
      }
      return true;
    });

    if (this.selectedSortOption['reversed']) {
      return _.sortBy(flats, this.selectedSortOption['key']).reverse();
    }

    return _.sortBy(flats, this.selectedSortOption['key']);
  }


  showFlat(flat) {

    if (flat.level !== this.selectedLevelOption['value'] && this.selectedLevelOption['value'] !== 'all') {
      return false;
    }

    if (flat.price > this.maxPriceValue) {
      return false;
    }

    if (flat.size < this.minSizeValue) {
      return false;
    }

    if (flat.numberOfRooms < this.minNumberOfRoomsValue || (this.minNumberOfRoomsValue > 1 && flat.isOffice)) {
      return false;
    }

    return true;

  }

  initSortOptions() {
    this.sortOptions = [
      {
        name: 'szint szerint növekvő',
        key: 'level'
      },
      {
        name: 'szint szerint csökkenő',
        key: 'level',
        reversed: true
      },
      {
        name: 'lakás számok szerint növekvő',
        key: 'name'
      },
      {
        name: 'lakás számok szerint csökkenő',
        key: 'name',
        reversed: true
      },
      {
        name: 'méret szerint növekvő',
        key: 'size'
      },
      {
        name: 'méret szerint csökkenő',
        key: 'size',
        reversed: true
      },
      {
        name: 'ár szerint növekvő',
        key: 'price'
      },
      {
        name: 'ár szerint csökkenő',
        key: 'price',
        reversed: true
      },
    ];
  }

  initLevelOptions() {
    this.levelOptions = [
      {
        name: 'pinceszint',
        value: 0
      },
      {
        name: 'földszint',
        value: 1
      },
      {
        name: '1. emelet',
        value: 2
      },
      {
        name: 'összes',
        value: 'all'
      },
    ];
  }

  initProjectOptions() {
    this.statusOptions = [
      {
        name: 'összes',
        value: 'ALL'
      },
      {
        name: 'eladó',
        value: 'FOR_SALE'
      },
      {
        name: 'eladva',
        value: 'SOLD'
      },
      {
        name: 'foglalt',
        value: 'RESERVED'
      },
    ];
  }

  removeHuf(priceString) {
    return priceString.replace('HUF', '');
  }
}

export interface StatusInterface {
  name?: string;
  value?: string;
}

